import { render, staticRenderFns } from "./mcm.vue?vue&type=template&id=453fa3be&scoped=true"
import script from "./mcm.vue?vue&type=script&lang=js"
export * from "./mcm.vue?vue&type=script&lang=js"
import style0 from "./mcm.vue?vue&type=style&index=0&id=453fa3be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453fa3be",
  null
  
)

export default component.exports